import type Account from "byzantine/src/Account";

export const mergeAccountsById = (
  existing: Account[],
  incoming: Account[]
): Account[] => {
  const byId = [...existing, ...incoming].reduce<Map<Account["id"], Account>>(
    (acc, account) => acc.set(account.id, account),
    new Map<Account["id"], Account>()
  );
  return Array.from(byId.values());
};
